// Browser-compatible canonicalization function extracted from canon.js
export function canonicalizeJSON(input, keysToDelete = []) {
  if (Array.isArray(input)) {
    if (input.length === 0) return [];

    // Sort each element recursively first
    let processed = input.map((el) => canonicalizeJSON(el, keysToDelete));

    // Sort arrays of objects by common identifiers or alphabetically first key
    if (input.every((el) => el && typeof el === 'object' && !Array.isArray(el))) {
      const potentialKeys = ['id', 'pk', 'uuid', '_id', 'uid', 'name', 'key'];
      let sortKey = potentialKeys.find((key) => processed[0] && key in processed[0]);

      if (!sortKey && processed[0]) {
        // fallback: pick alphabetically first key of the first element
        sortKey = Object.keys(processed[0]).sort()[0];
      }

      processed.sort((a, b) => {
        const va = a[sortKey];
        const vb = b[sortKey];
        if (va === undefined && vb === undefined) return 0;
        if (va === undefined) return -1;
        if (vb === undefined) return 1;
        return va < vb ? -1 : va > vb ? 1 : 0;
      });
    } else {
      // Sort arrays of non-objects (primitives, arrays, etc.)
      processed.sort((a, b) => {
        if (a === undefined && b === undefined) return 0;
        if (a === undefined) return -1;
        if (b === undefined) return 1;
        return a < b ? -1 : a > b ? 1 : 0;
      });
    }

    return processed;
  }

  if (input && typeof input === 'object') {
    // Sort object keys alphabetically
    const sortedKeys = Object.keys(input).sort();
    const result = {};
    for (const key of sortedKeys) {
      // Skip keys that are in the deletion list
      if (keysToDelete.includes(key)) {
        continue;
      }
      result[key] = canonicalizeJSON(input[key], keysToDelete);
    }
    return result;
  }

  // Primitive value
  return input;
}

export function canonicalizeAndStringify(jsonString, keysToDelete = []) {
  try {
    const parsed = JSON.parse(jsonString);
    const canonicalized = canonicalizeJSON(parsed, keysToDelete);
    return JSON.stringify(canonicalized, null, 2);
  } catch (error) {
    throw new Error(`Failed to canonicalize JSON: ${error.message}`);
  }
}
